import React from "react";
import SelectBox, { ISelectBoxOptions } from 'devextreme-react/select-box';

interface IPropsSelectWithLabel extends ISelectBoxOptions {
    inputLabel?: string;
    error?: any;
    touched?: any;
    children?: React.ReactNode;
}

function SelectWithLabel({ inputLabel, error, touched, children, ...props }: IPropsSelectWithLabel): React.ReactElement {
    return (
        <div className='dx-field'>
            <div className="dx-field-label">
                <strong>{inputLabel}</strong>
            </div>
            <div className='dx-field-value'>
                <SelectBox
                    focusStateEnabled={false}
                    hoverStateEnabled={false}
                    {...props}
                >
                    {children}
                </SelectBox>
                {error && touched ? <div className="alert alert-danger my-3">{error}</div> : null}
            </div>
        </div>
    )
}

export default React.memo(SelectWithLabel);